// extracted by mini-css-extract-plugin
module.exports = {"main":"ItemButton_main__umP_j","logo":"ItemButton_logo__GzwO4","content":"ItemButton_content__x21C4","arrDiv":"ItemButton_arrDiv__OCPRT"};